module.exports = __webpack_public_path__ + "static/img/lazy.d35f8087.gif";